import { Box, Button } from '@mui/material';
import EntityDetailPopup from '../EntityDetailPopup';

const DeleteAlertBox = props => {
  const {
    open,
    onClose,
    onDelete,
    currDarkThemeClass,
    headContentText = '',
    title = 'Are you sure you want to delete?',
    deleteBtn = 'Yes',
    cancelBtn = 'Cancel',
    disabled = false,
    ...otherProps
  } = props;

  const handleDelete = () => {
    //handle delete action
    onDelete();
    onClose();
  };

  const entityDetailPopupProps = {
    open,
    onClose,
    modalMaxWidth: '640px',
    toShowSave: false,
    title: title,
    headContentText: headContentText,
    currDarkThemeClass,
    ...otherProps,
  };

  return (
    <EntityDetailPopup {...entityDetailPopupProps}>
      <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', padding: 2, gap: 4 }}>
        <Button onClick={() => onClose()} color="error" variant="contained" autoFocus>
          {cancelBtn}
        </Button>
        <Button onClick={() => handleDelete()} color="primary" autoFocus variant="contained" disabled={disabled}>
          {deleteBtn}
        </Button>
      </Box>
    </EntityDetailPopup>
  );
};

export default DeleteAlertBox;
